import React, { useState, useEffect, useRef } from "react";

import { useNotify, useRedirect } from "react-admin";
import { API, graphqlOperation } from "aws-amplify";
import { getAudit, accountByActiveByName } from "../../../graphql/queries";
import { updateAuditInventorie } from "../../../graphql/inventory/custom-mutations";
import { AuditStatus, InventoryStatus } from "../../../utils/constants";
import { getAuditNextItems } from "../../../graphql/audit/custom-queries";
import { inventoryByStatusByLocationIdByAccountId } from "../../../graphql/inventory/custom-queries";

import { CircularProgress } from "@material-ui/core";
import { logError } from "../../../utils/appUtils";
import { getLocationViewName } from "../../../utils/locationUtils";
import { makeStyles } from "@material-ui/core/styles";
import ErrorCard from "../../../components/ErrorCard";
import AuditSummary from "./AuditSummary";
import YardLocations from "./YardLocations";
import { InventoryList } from "./InventoryList";
import ViewAudit from "./ViewAudit";
import { getNextItem, setNextItem, saveAudit } from "./Audit";

const useStyles = makeStyles((theme) => ({
  progress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
}));

const AuditContainer = ({ match, history }) => {
  const classes = useStyles();
  const notify = useNotify();
  const redirect = useRedirect();
  const isComponentMounted = useRef(true);
  const [inventories, setInventories] = useState([]);
  const [currentAudit, setCurrentAudit] = useState();
  const [loading, setLoading] = useState(false);
  const [completedFlag, setCompletedFlag] = useState();
  const [completedLocations, setCompletedLocations] = useState(0);
  const [locationMode, setLocationMode] = React.useState(false);
  const [accounts, setAccounts] = useState([]);
  const [invalidIdError, setInvalidIdError] = useState();
  const [locations, setLocations] = useState();
  const [viewState, setViewState] = useState("VIEW");

  useEffect(() => {
    init();
    getAccounts();
    // let updateAuditListener;
    // Auth.currentAuthenticatedUser()
    // .then(user => {
    //     updateAuditListener = API.graphql(graphqlOperation(onUpdateAudit, {
    //         owner: user.username
    //     })).subscribe({
    //         next: auditData => {
    //             let data = auditData.value.data.onUpdateAudit;
    //             setCurrentAudit(setCurrentAuditData(data));
    //         }
    //     })
    // });
    return () => {
      isComponentMounted.current = false;
      debugger;
      // updateAuditListener.unsubscribe();
    };
  }, []);

  const init = async () => {
    if (loading) return;
    setLoading(true);
    try {
      debugger;
      let response = await API.graphql(
        graphqlOperation(getAudit, { id: match.params.id })
      );
      if (response.data.getAudit) {
        const audit = setCurrentAuditData(response.data.getAudit);
        setCurrentAudit(audit);
        setLocations(audit.locations);
        computeCompleted(audit);
        const nextItem = history.location.state?.index
          ? history.location.state.index
          : getNextItem(audit);
        debugger;
        // await getInventories(nextItem, audit);
        setNextItem(audit, nextItem);
      } else {
        setInvalidIdError(`Audit ID ${match.params.id} doesn't exist.`);
      }
    } catch (err) {
      logError("AuditContainer:init", err, notify);
    } finally {
      setLoading(false);
    }
  };

  const getAccounts = async () => {
    try {
      const response = await API.graphql(
        graphqlOperation(accountByActiveByName, {
          reloadYardId: window.appUser?.reloadYardId,
          activeBusinessName: { beginsWith: { active: "true" } },
        })
      );
      debugger;
      setAccounts(response.data.accountByActiveByName.items);
    } catch (err) {
      logError("AuditContainer:getAccounts", err, notify);
    }
  };

  // const getInventories = async (idx, audit) => {
  //     if (!isComponentMounted) return;
  //     debugger;
  //     try {
  //         if (idx >= audit.locations.length) {
  //             setInventories([]);
  //             processNextItems(audit);
  //         } else {
  //             const input = {
  //                 reloadYardId: window.appUser.reloadYardId,
  //                 statusLocationIdAccountId: {
  //                     beginsWith: {
  //                         status: InventoryStatus.STORED,
  //                         locationId: audit.locations[idx]
  //                     }},
  //             };
  //             if (audit.accountId) {
  //                 input.statusLocationIdAccountId.beginsWith = {
  //                         status: InventoryStatus.STORED,
  //                         locationId: audit.locations[idx],
  //                         accountId: audit.accountId
  //                     }
  //             }

  //             const response = await API.graphql(graphqlOperation(inventoryByStatusByLocationIdByAccountId, input));
  //             const data = response.data.inventoryByStatusByLocationIdByAccountId;

  //             debugger
  //             if (data.items.length > 0) {
  //                 setInventories(data.items);
  //                 if (!audit) audit = currentAudit;
  //                 audit.processedLocations[audit.locations[idx]] = {
  //                     total: data.items.length,
  //                     completed: getCompletedItemsCount(data.items, audit)
  //                 }
  //             } else {
  //                 setInventories([]);
  //                 processNextItems(audit);
  //             }
  //         }
  //     } catch (err) {
  //         logError("audit:AuditContainer:getInventories", err, notify);
  //     }
  // }

  const computeCompleted = (audit) => {
    let completedCount = 0;
    Object.keys(audit.processedLocations).forEach((key) => {
      if (
        audit.processedLocations[key].completed ===
        audit.processedLocations[key].total
      )
        completedCount++;
    });
    setCompletedLocations(completedCount);
    return completedCount;
  };

  const isCompleted = (audit) => {
    debugger;
    if (!audit) audit = currentAudit;
    const processedLocations = Object.keys(audit.processedLocations);
    if (
      processedLocations &&
      locations.length !== Object.keys(audit.processedLocations).length
    )
      return false;
    let completed = true;
    Object.keys(audit.processedLocations).forEach((key) => {
      const itm = audit.processedLocations[key];
      if (itm.completed !== itm.total) completed = itm.false;
    });
    return completed;
  };

  const getCompletedItemsCount = (items, audit) => {
    debugger;
    let count = 0;
    items.forEach((itm) => {
      count =
        audit.processedItems.findIndex(
          (processedItm) => processedItm.id === itm.id
        ) === -1
          ? count
          : count + 1;
    });
    return count;
  };

  const processNextItems = (audit) => {
    debugger;
    const completedCount = computeCompleted(audit);
    if (completedCount === audit.locations.length) {
      // XXXX changed from locations.length since it was not yet populated
      debugger;
      setCompletedFlag(true);
    } else {
      debugger;
      setLocationMode(true);
    }
  };

  const setCurrentAuditData = (audit) => {
    debugger;
    if (typeof audit.processedItems === "string") {
      audit.processedItems = !audit.processedItems
        ? []
        : JSON.parse(audit.processedItems);
    }
    if (typeof audit.skippedItems === "string") {
      audit.skippedItems = !audit.skippedItems
        ? []
        : JSON.parse(audit.skippedItems);
    }
    if (typeof audit.processedLocations === "string") {
      audit.processedLocations = !audit.processedLocations
        ? {}
        : JSON.parse(audit.processedLocations);
    }
    return audit;
  };

  const setNextItems = async (audit) => {
    if (loading) return;
    debugger;
    let response = await API.graphql(
      graphqlOperation(getAuditNextItems, {
        id: audit.id,
      })
    );
    const nextItems = response.data.getAudit.nextItems;
    if (response.data.getAudit.processedItems) {
      const processedItems = JSON.parse(response.data.getAudit.processedItems);
      Object.keys(processedItems).forEach((k) => {
        if (!audit.processedItems[k])
          audit.processedItems[k] = processedItems[k];
      });
    }
    const idx = audit.nextItems.findIndex(
      (itm) => itm.owner === window.appUser?.fullName
    );
    audit.nextItems = nextItems.map((itm) =>
      itm.owner !== window.appUser?.fullName ? itm : audit.nextItems[idx]
    );
  };

  const saveAuditData = async (audit, inventoryItem) => {
    try {
      await setNextItems(audit);
      if (!audit.startDateTime) {
        audit.startDateTime = new Date();
      }
      const updatedAudit = await saveAudit(audit);
      setCurrentAudit(setCurrentAuditData(updatedAudit));
      if (inventoryItem) {
        const toUpdateInventory = { ...inventoryItem };
        delete toUpdateInventory.location;
        delete toUpdateInventory.account;
        delete toUpdateInventory.product;
        delete toUpdateInventory.createdAt;
        delete toUpdateInventory.updatedAt;

        toUpdateInventory.auditId = updatedAudit.id;
        const response = await API.graphql(
          graphqlOperation(updateAuditInventorie, { input: toUpdateInventory })
        );
        const newInventory = response.data.updateAuditInventorie;
        setInventories(
          inventories.map((itm) =>
            itm.id === newInventory ? newInventory : itm
          )
        );
        debugger;
      }
    } catch (err) {
      logError("AuditContainer:saveAuditData", err, notify, redirect);
    }
  };

  const handleCompletedLocation = (inventoryItem) => {
    debugger;
    currentAudit.processedLocations[inventoryItem.location.id].completed++;
  };

  const handleComplete = async (inventoryItem) => {
    const processedItmIdx = currentAudit.processedItems.findIndex(
      (itm) => itm.id === inventoryItem.id
    );
    if (processedItmIdx === -1) {
      currentAudit.processedItems = [
        ...currentAudit.processedItems,
        inventoryItem,
      ];
      handleCompletedLocation(inventoryItem);
    }
    const completedCount = computeCompleted(currentAudit);
    currentAudit.skippedItems = currentAudit.skippedItems.filter(
      (skipped) => skipped.id !== inventoryItem.id
    );
    debugger;
    let newInventories;

    if (inventoryItem.location.id !== locations[getNextItem(currentAudit)])
      newInventories = inventories.filter((itm) => itm.id !== inventoryItem.id);
    else
      newInventories = inventories.map((itm) =>
        itm.id === inventoryItem.id ? inventoryItem : itm
      );

    setCurrentAudit({ ...currentAudit });
    await saveAuditData(currentAudit, inventoryItem);
    if (completedCount === locations.length) {
      debugger;
      setCompletedFlag(true);
    } else {
      setInventories(newInventories);
    }
  };

  const handleSkip = async (inventoryItem) => {
    debugger;
    const skippedItmIdx = currentAudit.skippedItems.findIndex(
      (itm) => itm.id === inventoryItem.id
    );
    if (skippedItmIdx === -1) {
      currentAudit.skippedItems = [...currentAudit.skippedItems, inventoryItem];
    }
    // setInventories(remainingInventories);
    saveAuditData(currentAudit);
    const remainingInventories = inventories.filter(
      (item) => !currentAudit.skippedItems?.includes(item)
    );
    if (remainingInventories.length === 0) {
      let nextItem = getNextItem(currentAudit);
      setNextItem(currentAudit, nextItem + 1);
      const updatedAudit = { ...currentAudit };
      setCurrentAudit(updatedAudit);
      // await getInventories(nextItem + 1, updatedAudit);
    }
  };

  const handleAddSkipped = (inventoryItem) => {
    setInventories([inventoryItem, ...inventories]);
  };

  const handleBack = async () => {
    debugger;
    let nextItem = getNextItem(currentAudit);
    // await getInventories(nextItem - 1, currentAudit);
    setNextItem(currentAudit, nextItem - 1);
    await setNextItems(currentAudit);
    setCurrentAudit({ ...currentAudit });
    debugger;
  };

  const handleLocation = async (idx) => {
    debugger;
    // await getInventories(idx, currentAudit);
    setNextItem(currentAudit, idx);
    setCurrentAudit({ ...currentAudit });
    setLocationMode(false);
  };

  const handleNext = async () => {
    let nextItem = getNextItem(currentAudit);
    setNextItem(currentAudit, nextItem + 1);
    // nextItem < locations.length && await getInventories(nextItem + 1, currentAudit);
  };

  const finishAudit = async (audit) => {
    if (!isCompleted()) return;
    try {
      debugger;
      const updatedAudit = {
        ...audit,
        status: AuditStatus.PENDING_REVIEW,
        endDateTime: new Date(),
      };
      await saveAudit(updatedAudit);
      setInventories([]);
      setCompletedFlag(false);
      returnToAudit(false);
    } catch (err) {
      logError("AuditContainer:finishAudit", err, notify, redirect);
    }
  };

  const returnToAudit = async (saveFlag = true) => {
    if (saveFlag) {
      saveAuditData(currentAudit);
    }
    debugger;
    history.push("/processAudit");
  };

  const returnList = () => {
    debugger;
    setLocationMode(false);
  };

  return loading ? (
    <div className={classes.progress}>
      <CircularProgress />
    </div>
  ) : invalidIdError ? (
    <ErrorCard error={invalidIdError} />
  ) : locationMode ? (
    <YardLocations
      locations={locations}
      handleCancel={inventories.length === 0 ? returnToAudit : returnList}
      handleLocation={handleLocation}
      currentAudit={currentAudit}
      buttonLabel={inventories.length === 0 ? "Complete later" : "close"}
      accounts={accounts}
      disableAccounts={true}
    />
  ) : completedFlag ? (
    <AuditSummary
      currentAudit={currentAudit}
      locations={locations}
      finishAudit={finishAudit}
      saveAudit={saveAudit}
      isCompleted={isCompleted}
    />
  ) : viewState === "VIEW" ? (
    currentAudit ? (
      <ViewAudit
        audit={currentAudit}
        history={history}
        match={match}
        setViewState={setViewState}
        returnToAudit={returnToAudit}
      />
    ) : null
  ) : (
    <InventoryList
      handleSkip={handleSkip}
      handleComplete={handleComplete}
      handleBack={handleBack}
      handleNext={handleNext}
      currentAudit={currentAudit}
      inventories={inventories}
      handleAddSkipped={handleAddSkipped}
      title={getLocationViewName(
        window.appUser.reloadYard.locationMap[
          locations[getNextItem(currentAudit)]
        ]
      )}
      disableBack={getNextItem(currentAudit) === 0}
      returnToAudit={returnToAudit}
      locations={locations}
      completedLocations={completedLocations}
      setLocationMode={setLocationMode}
      isCompleted={isCompleted}
    />
  );
};

export default AuditContainer;
